import { Checkbox } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { EligibilityRule } from '../../../models';
import { FlexBox } from '../flex-box';

interface Props {
  eligibilityRules: EligibilityRule[];
  selectedEligibilityRuleCodes: string[];
  onEligibilityRulesChanged?: () => void;
}

const AssignEligibilityRules: React.FC<Props> = props => {
  const {
    eligibilityRules,
    selectedEligibilityRuleCodes,
    onEligibilityRulesChanged,
  } = props;

  const isEligibilityRuleSelected = (ruleCode: string): boolean => {
    return selectedEligibilityRuleCodes.some(code => ruleCode === code);
  }

  return (
    <FlexBox
      direction='column'
      className='assign-eligibility-rules'
    >
      {
        eligibilityRules.map((eligibilityRule) => {
          return (
            <Checkbox
              key={eligibilityRule.eligibilityRuleId}
              label={eligibilityRule.displayName}
              checked={isEligibilityRuleSelected(eligibilityRule.code)}
              onChange={(_, data) => {
                if (data.checked) {
                  selectedEligibilityRuleCodes.push(eligibilityRule.code);
                  onEligibilityRulesChanged && onEligibilityRulesChanged();
                  return;
                }

                const indexToRemove = selectedEligibilityRuleCodes.indexOf(eligibilityRule.code);
                selectedEligibilityRuleCodes.splice(indexToRemove, 1);
                onEligibilityRulesChanged && onEligibilityRulesChanged();
              }}
            />
          );
        })
      }
    </FlexBox>
  );
}

export default observer(AssignEligibilityRules);
